import { render, staticRenderFns } from "./SortableColumnHeader.vue?vue&type=template&id=607fb557&scoped=true&"
import script from "./SortableColumnHeader.vue?vue&type=script&setup=true&lang=js&"
export * from "./SortableColumnHeader.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607fb557",
  null
  
)

export default component.exports